const BASE_PATH = process.env.base_path;
const ENV = process.env.ENV;
const HOME_URL = process.env.home_url;
const WEB_USERNAME = process.env.WEB_USERNAME;
const WEB_PASS = process.env.WEB_PASS;
const ASSETS_URL = process.env.ASSETS_URL;
const recaptcha_site_key = process.env.recaptcha_site_key
const recaptcha_v2_site_key = process.env.recaptcha_v2_site_key

export {
	BASE_PATH,
	ENV,
	HOME_URL,
	WEB_USERNAME,
	WEB_PASS,
	ASSETS_URL,
	recaptcha_site_key,
	recaptcha_v2_site_key
};
